import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpComponent } from './help.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { HelpDocsService } from './share/help-docs.service';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  declarations: [HelpComponent],
  imports: [
    CommonModule,
    PdfViewerModule,
    MatSnackBarModule,
    FormsModule,
    SharedModule,
  ],
  exports: [HelpComponent],
  providers: [HelpDocsService],
})
export class HelpModule {}
